function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (categories, col, klass) {
      var col = 12 / categories.length;
var klass = "col-sm-" + col + " col-md-" + col;
pug_html = pug_html + "\u003Cdiv class=\"content-ver block-v-md\"\u003E\u003Cdiv class=\"row text-center\"\u003E";
// iterate categories
;(function(){
  var $$obj = categories;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var category = $$obj[i];
pug_html = pug_html + "\u003Ch2" + (pug_attr("class", pug_classes(["tight","game-category-title",klass], [false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"content-ver\"\u003E" + (null == (pug_interp = category.title) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fh2\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var category = $$obj[i];
pug_html = pug_html + "\u003Ch2" + (pug_attr("class", pug_classes(["tight","game-category-title",klass], [false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"content-ver\"\u003E" + (null == (pug_interp = category.title) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fh2\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"row text-center\"\u003E";
// iterate categories
;(function(){
  var $$obj = categories;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var category = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["game-category",klass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"block-v-sm\"\u003E";
// iterate category.questions
;(function(){
  var $$obj = category.questions;
  if ('number' == typeof $$obj.length) {
      for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
        var question = $$obj[j];
pug_html = pug_html + "\u003Cdiv" + (" class=\"btn-question block-v-sm\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["block-md","block-dk",`stars-${j + 1}`], [false,false,true]), false, true)+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (" class=\"text-lg\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = (j + 1) * 200) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;
      var question = $$obj[j];
pug_html = pug_html + "\u003Cdiv" + (" class=\"btn-question block-v-sm\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["block-md","block-dk",`stars-${j + 1}`], [false,false,true]), false, true)+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (" class=\"text-lg\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = (j + 1) * 200) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var category = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["game-category",klass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"block-v-sm\"\u003E";
// iterate category.questions
;(function(){
  var $$obj = category.questions;
  if ('number' == typeof $$obj.length) {
      for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
        var question = $$obj[j];
pug_html = pug_html + "\u003Cdiv" + (" class=\"btn-question block-v-sm\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["block-md","block-dk",`stars-${j + 1}`], [false,false,true]), false, true)+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (" class=\"text-lg\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = (j + 1) * 200) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;
      var question = $$obj[j];
pug_html = pug_html + "\u003Cdiv" + (" class=\"btn-question block-v-sm\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["block-md","block-dk",`stars-${j + 1}`], [false,false,true]), false, true)+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E\u003Cdiv" + (" class=\"text-lg\""+pug_attr("data-category", i, true, true)+pug_attr("data-question", j, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = (j + 1) * 200) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "categories" in locals_for_with ?
        locals_for_with.categories :
        typeof categories !== 'undefined' ? categories : undefined, "col" in locals_for_with ?
        locals_for_with.col :
        typeof col !== 'undefined' ? col : undefined, "klass" in locals_for_with ?
        locals_for_with.klass :
        typeof klass !== 'undefined' ? klass : undefined));
    ;;return pug_html;};module.exports=template;